import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SamplingSurfacePointPanel from './samplingSurfacePoint/SamplingSurfacePointPanel'
import DtoPoint from '../../../dto/DtoPoint'
import TitlePanel from '../../util/TitlePanel'
import i18n from 'simple-react-i18n'
import { PANEL_QUALITY_ANALYSIS, PANEL_QUALITY_SAMPLING_POINTS } from '../../../constants/PointConstants'
import NoInformationPanel from '../../util/NoInformationPanel'
import DtoSamplingSurfacePoint from '../../../dto/DtoSamplingSurfacePoint'
import SiteTypes from '../../../../utils/mapUtils/SiteTypes'

class QualityPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			panel: PANEL_QUALITY_ANALYSIS
		}
	}

	getSurfaceQualitometerTabs = () => {
		return [
			{
				title: i18n.description,
				value: PANEL_QUALITY_ANALYSIS,
				active: true
			},
			{
				title: i18n.point.samplingPoint + '(' + this.props.samplingSurfacePoints.length + ')',
				value: PANEL_QUALITY_SAMPLING_POINTS,
				active: false
			}
		]
	}
	getQualitometerTabs = () => {
		return [
			{
				title: i18n.description,
				value: PANEL_QUALITY_ANALYSIS,
				active: true
			}
		]
	}

	getTabs = () => {
		const tabs = (() => {
			switch (this.props.point.typeParameter) {
				case SiteTypes.QUALITOMETER_SURFACE.type:
					return this.getSurfaceQualitometerTabs()
				default:
					return this.getQualitometerTabs()
			}
		})()
		if (tabs.length > 1) {
			const finalTabs = tabs.map((o) => {
				if (o.active) {
					return (<li className='tab active'><a onClick={ () => this.changePanel(o.value) }>{ o.title }</a></li>)
				}
				return (<li className='tab'><a onClick={ () => this.changePanel(o.value) }>{ o.title }</a></li>)
			})
			return (
				<ul className='tabs tabs-fixed-width'>
					{ finalTabs }
				</ul>
			)
		}
		return null
	}

	changePanel = (value) => {
		this.setState({
			panel: value
		})
	}

	getPanel = () => {
		switch (this.state.panel) {
			case PANEL_QUALITY_ANALYSIS:
				return (<NoInformationPanel/>)
			case PANEL_QUALITY_SAMPLING_POINTS:
				return (<SamplingSurfacePointPanel/>)
			default:
				return null
		}
	}

	render() {
		return (
			<div className='row card no-margin'>
				<div className='row no-margin'>
					<div className='col s12 no-padding'>
						<b>
							<TitlePanel title={ i18n.quality }/>
						</b>
					</div>
				</div>

				<div className='row no-margin'>
					<div className='col s12 no-padding'>
						{ this.getTabs() }
					</div>
				</div>
				<div className='row no-margin'>
					{ this.getPanel() }
				</div>
			</div>
		)
	}

	componentDidUpdate() {
		$('ul.tabs').tabs()
	}

	componentDidMount() {
		$('ul.tabs').tabs()
	}
}

QualityPanel.propTypes = {
	point: PropTypes.objectOf(DtoPoint),
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.objectOf(DtoSamplingSurfacePoint))
}
const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		samplingSurfacePoints: store.PointReducer.samplingSurfacePoints
	}
}

export default connect(mapStateToProps)(QualityPanel)



// WEBPACK FOOTER //
// ./src/point/components/pointType/quality/QualityPanel.js